var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{ref:"submenuLink",attrs:{"href":_vm.link},on:{"focus":function($event){return _vm.onFocus()}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }